module.exports = __webpack_public_path__ + "img/qingTran.180ca0e1.png";